<template>
  <div class="service-nww-stop-alarm">
    <p>
      {{ $t('messages.alarms.serviceNWWStopAlarm.attention') }}
    </p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <p
      v-if="!store.getData('user.access.programEdit')"
      class="g-alarm-handler__highlight g-alarm-handler__highlight--yellow"
    >
      <strong>{{ $t('messages.alarms.attention') }}</strong>: {{ $t('messages.alarms.serviceNWWStopAlarm.attention') }}
    </p>

    <hr>

    <!-- <div class="g-alarm-handler__row">
      <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceNWWStopAlarm.suggestion') }}</p>
    </div> -->

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    />

    <div class="g-text g-text--center">
      <button
        type="button"
        class="g-btn g-btn--rounded g-btn--blue"
        @click.stop="$router.push('/programs')"
      >
        {{ $t('messages.alarms.serviceNWWStopAlarm.editInPrograms') }} <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </button>
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceNWWStopAlarm',
  mixins: [ServiceAlarm]
}
</script>